import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  Container,
  Row,
  Col,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap'
import './terms.scss'
import termsService from '../../api/services/termsService'
import * as actionsCookies from '../../actions/cookies'
import * as actionsTerms from '../../actions/terms'
import Parser from 'html-react-parser'

import NewHeader from '../../components/layout/NewHeader/NewHeader'
import { injectIntl, FormattedMessage } from 'react-intl'
import styled from 'styled-components/macro'
import { theme } from 'styled-tools'
import PropTypes from 'prop-types'

const Link = styled.a``

const TermsPane = styled(Col)`
  a {
    color: ${theme('hyperlink')} !important;
    &:hover {
      text-decoration: underline !important;
    }
  }
`

class Terms extends React.PureComponent {
  constructor (props) {
    super(props)

    this.toggle = this.toggle.bind(this)
    this.state = {
      activeTab: '0',
      error: null
    }
    this.tabs = [
      {
        tabId: '1',
        tabName: props.intl.formatMessage({ id: 'terms.termsOfService' }),
        contentSelector: state => state.terms.terms_of_service
      },
      {
        tabId: '2',
        tabName: props.intl.formatMessage({
          id: 'terms.merchantTermsOfService'
        }),
        contentSelector: state => state.terms.merchant_terms_of_service
      },
      {
        tabId: '3',
        tabName: props.intl.formatMessage({
          id: 'terms.additionalTermsOfService'
        }),
        contentSelector: state => state.terms.additional_terms_of_service
      },
      {
        tabId: '4',
        tabName: props.intl.formatMessage({ id: 'terms.privacyPolicy' }),
        contentSelector: state => state.terms.privacy_policy
      },
      {
        tabId: '5',
        tabName: props.intl.formatMessage({
          id: 'terms.prohibitedRestrictedItems'
        }),
        contentSelector: state => state.terms.prohibited_and_restricted_items
      }
    ]
  }

  componentDidMount () {
    // gets state of checkob hidden in index.html
    const { match } = this.props
    const activeTab = match.params.activeTab || '1'
    this.getTerms()
    this.toggle(activeTab)
  }

  componentDidUpdate () {
    if (this.props.match.params.activeTab) {
      this.toggle(this.props.match.params.activeTab)
    }
  }

  async getTerms () {
    if (
      !(
        this.props.terms.terms &&
        this.props.terms.terms.version !== this.props.terms.latest
      )
    ) {
      try {
        const resp = await termsService.getTerms()
        this.props.actionsTerms.setTerms(resp)
        this.createAcceptedCheckBox()
      } catch (err) {
        this.setState({ error: err.message })
      }
    }
  }

  createAcceptedCheckBox () {
    const checkbox = document.createElement('input')
    checkbox.id = 'csconsentcheckbox'
    checkbox.type = 'checkbox'
    checkbox.addEventListener('change', ev => {
      if (ev.target.checked) {
        this.props.actionsCookies.accept()
      } else {
        this.props.actionsCookies.disagree()
      }
    })
    const policyText = document.getElementById('privacyPolicyAcceptation')
    checkbox.checked = this.props.cookies.accepted
    policyText.parentNode.insertBefore(checkbox, policyText)
  }

  toggle (tabId) {
    if (this.state.activeTab !== tabId) {
      const dynamicTitle = this.tabs
        .find(tab => tab.tabId === tabId)
        .tabName.replace(/ /g, '-')
      this.setState({
        activeTab: tabId
      })
      // this.prop.match.path = '/terms/:activeTab?/:tabName?';
      // get parent pathname for replace
      const currentParentRout = this.props.match.path.split('/')[1]
      this.props.history.replace(
        `/${currentParentRout}/${tabId}/${dynamicTitle}`
      )
    }
  }

  tabNav () {
    const { activeTab } = this.state
    return (
      <Nav
        tabs
        className='d-flex justify-content-center flex-lg-row flex-column text-center'
      >
        {this.tabs.map(tab => (
          <NavItem key={tab.tabId}>
            <NavLink
              className={`${activeTab === tab.tabId && 'active'}`}
              onClick={() => {
                this.toggle(tab.tabId)
              }}
            >
              {tab.tabName}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
    )
  }

  tabContent () {
    const { activeTab } = this.state
    const { terms } = this.props

    return (
      <TabContent activeTab={activeTab}>
        {this.tabs.map(tab => (
          <TabPane key={tab.tabId} tabId={tab.tabId}>
            <Row>
              <TermsPane md={{ size: 10, offset: 1 }}>
                {Parser(tab.contentSelector(terms), {
                  replace: domNode => {
                    if (
                      domNode.attribs &&
                      domNode.attribs.id === 'anchorToReplace'
                    ) {
                      return (
                        <Link onClick={() => this.toggle(domNode.attribs.tab)}>{domNode.children[0].data}</Link>
                      )
                    }
                  }
                })}
              </TermsPane>
            </Row>
          </TabPane>
        ))}
      </TabContent>
    )
  }

  render () {
    const { error } = this.state
    return (
      <React.Fragment>
        <NewHeader breadcrumbTitle={this.props.breadcrumb || ''}>
          <h1 className='text-center'>
            <FormattedMessage id='terms.title' />
          </h1>
        </NewHeader>
        <div className='terms'>
          <Container fluid className='p-0 wide-line'>
            <Container>
              <Row>
                <Col />
                <Col md='12' style={{ textAlign: 'center' }}>
                  {error || this.tabNav()}
                </Col>
              </Row>
            </Container>
          </Container>
          <Container>{this.props.terms.terms && this.tabContent()}</Container>
        </div>
      </React.Fragment>
    )
  }
}

Terms.propTypes = {
  breadcrumb: PropTypes.string,
  intl: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  terms: PropTypes.object.isRequired,
  actionsTerms: PropTypes.object.isRequired,
  actionsCookies: PropTypes.object.isRequired,
  cookies: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
}

const mapStateToProps = state => {
  return {
    cookies: state.cookies,
    terms: state.terms
  }
}

const mapDispatchToProps = dispatch => ({
  actionsCookies: bindActionCreators(actionsCookies, dispatch),
  actionsTerms: bindActionCreators(actionsTerms, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(Terms))
